import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Store } from 'src/app/models/contest';

@Component({
  selector: 'app-store-list',
  templateUrl: './store-list.component.html',
  styleUrls: ['./store-list.component.scss'],
})
export class StoreListComponent  implements OnInit {

  @Input() contestStores: Array<Store> = [];


  constructor(private modalCtrl: ModalController) { }

  ngOnInit() { }


  close() {
    this.modalCtrl.dismiss();
  }

}
